import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';

import { ReactionTabs } from './ReactionTabs/ReactionTabs';
import { UserList } from './UserList';
import usePresenter from './presenter';

interface IReactionsDetailedPopupParams {
  groupId: string;
  messageId: string;
  tab?: string;
}

export const ReactionsDetailedPopup: FC<ICommonPopupsProps<IReactionsDetailedPopupParams>> =
  observer(({ params, popupInstance }) => {
    const { t } = useTranslation();
    const { tabs } = usePresenter(params, popupInstance);
    useClosePopupOnNavigation(popupInstance);

    return (
      <Popup
        title={t('group_chat_actions_sheet_info')}
        isOpened
        onClose={popupInstance.close}
      >
        {tabs.hasTabs && (
          <>
            <ReactionTabs tabs={tabs.tabsList} />
            <UserList tabs={tabs} />
          </>
        )}
      </Popup>
    );
  });
